import { render, staticRenderFns } from "./Organisation.vue?vue&type=template&id=f2609d22&scoped=true&"
import script from "./Organisation.vue?vue&type=script&lang=ts&"
export * from "./Organisation.vue?vue&type=script&lang=ts&"
import style0 from "./Organisation.vue?vue&type=style&index=0&id=f2609d22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2609d22",
  null
  
)

export default component.exports